/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * PwC Web App Accelerator API
 * OpenAPI spec version: 1.0
 */

export type CleanseDataType =
    (typeof CleanseDataType)[keyof typeof CleanseDataType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CleanseDataType = {
    NUMBER_6: 6,
    NUMBER_7: 7,
} as const;
